import memoize from "memoize-one"

import { itemBaseType } from "constants/enums"

export const mapTopicsIntoSuggestions = memoize(items =>
    items.map(item => ({
        hash: item?.hash,
        value: item?.title,
        type: itemBaseType.journeyTopicItem,
    })),
)

export const mapStoriesIntoSuggestions = memoize(items =>
    items.map(item => ({
        hash: item?.hash,
        value: item?.title,
        type: itemBaseType.stepContentItem,
    })),
)

export const mapTodosIntoSuggestions = memoize(items =>
    items.map(item => ({
        hash: item?.hash,
        value: item?.actionTodo,
        type: itemBaseType.stepTodoItem,
    })),
)

export const suggestionsMappers = {
    [itemBaseType.journeyTopicItem]: mapTopicsIntoSuggestions,
    [itemBaseType.stepContentItem]: mapStoriesIntoSuggestions,
    [itemBaseType.stepTodoItem]: mapTodosIntoSuggestions,
}

export const deletePrerequisites = (data, prerequisites) => {
    const allPrerequisites = [
        ...(prerequisites?.sources || []),
        ...(prerequisites?.targets || []),
    ]
    const updatedData = { ...data }

    for (let idx = 0; idx < allPrerequisites?.length; idx += 1) {
        const prerequisite = allPrerequisites?.[idx]

        delete updatedData[prerequisite?.prerequisiteHash]
    }

    return updatedData
}
